import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 4, viewBox: "0 0 7 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.500155 0.500077L3.49992 3.5L6.49985 0.499923", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgArrowDown;
